import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Pierwszy kredyt hipoteczny to wejście w świat formalności, których nie tłumaczy
        Ci nikt poza doradcą banku — a ten ma swój interes. Proces od pierwszej wizyty
        w banku do podpisania aktu notarialnego trwa zwykle 2-4 miesiące i wymaga
        przejścia przez 7 konkretnych etapów. Ten poradnik pokazuje całą ścieżkę krok
        po kroku, z punktu widzenia osoby kupującej <strong>pierwsze mieszkanie</strong> w Polsce
        w 2026 roku.
      </p>

      <div className="mt-6 p-4 rounded-xl bg-gradient-to-br from-indigo-50 to-violet-50 border border-indigo-200">
        <p className="text-sm font-semibold text-foreground mb-2">W skrócie</p>
        <p className="text-sm">
          Aby dostać kredyt hipoteczny na pierwsze mieszkanie potrzebujesz: <strong>10-20%
          wkładu własnego</strong>, zdolności kredytowej (rata poniżej 35% dochodu netto),
          udokumentowanego źródła dochodu, pozytywnej historii w BIK i mieszkania, które
          przejdzie wycenę banku. Cały proces zajmuje 2-4 miesiące — opisany niżej krok
          po kroku.
        </p>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Krok 1: Sprawdź swoją zdolność kredytową i realny budżet</h2>
      <p>
        Zanim zaczniesz oglądać mieszkania, musisz wiedzieć ile bank Ci pożyczy.
        <strong> Zdolność kredytowa</strong> to maksymalna kwota, jaką bank uzna, że
        jesteś w stanie spłacać przy Twoich dochodach. Według <strong>Rekomendacji S
        Komisji Nadzoru Finansowego</strong> bezpieczna rata to maksymalnie 35% dochodu
        netto, a komfortowa — 25-30%.
      </p>
      <p className="mt-3">
        Sam możesz oszacować zdolność wstępnie: weź dochód netto, odejmij stałe wydatki
        i istniejące zobowiązania (raty, karty kredytowe — bank liczy cały limit jako
        zobowiązanie). To, co zostaje, pomnożone przez 0,35 daje Ci maksymalną
        miesięczną ratę.
      </p>
      <div className="bg-muted/50 rounded-xl p-4 mt-4">
        <p className="font-semibold mb-2">Przykład — singiel z dochodem 7 500 zł netto:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Maksymalna rata = 7 500 × 0,35 = <strong>2 625 zł</strong></li>
          <li>Przy oprocentowaniu 6,1% i 25 latach = kredyt ok. <strong>355 000 zł</strong></li>
          <li>Z 20% wkładem własnym — mieszkanie do <strong>~444 000 zł</strong></li>
        </ul>
      </div>
      <p className="mt-3">
        Szczegóły wyliczeń znajdziesz w artykule
        o <BlogLink slug="jak-obliczyc-zdolnosc-kredytowa">obliczaniu zdolności kredytowej</BlogLink>,
        a konkretne kwoty wymaganego dochodu — w <BlogLink slug="ile-zarabiac-na-kredyt-hipoteczny">poradniku
        o zarobkach a kredycie</BlogLink>.
      </p>
      <div className="mt-4">
        <CalculatorLink section="affordability">
          Sprawdź swoją zdolność w kalkulatorze
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Krok 2: Zbierz wkład własny — minimum 10%, optymalnie 20%</h2>
      <p>
        <strong>Wkład własny</strong> to część wartości mieszkania, którą wnosisz z gotówki.
        Rekomendacja S KNF wymaga minimum <strong>20%</strong> — przy zakupie mieszkania za
        500 000 zł oznacza to 100 000 zł w gotówce. Większość banków pozwala obniżyć
        wkład do <strong>10%</strong>, ale wtedy płacisz dodatkowe ubezpieczenie niskiego
        wkładu, które podnosi koszt kredytu.
      </p>
      <p className="mt-3">
        Pierwsi kredytobiorcy często zapominają, że <strong>wkład własny to nie wszystko</strong>.
        Do budżetu trzeba doliczyć <strong>3-5% wartości nieruchomości</strong> na koszty
        transakcyjne (taksa notarialna, podatek PCC 2% przy rynku wtórnym, prowizja
        banku, wycena, ubezpieczenia). Dla mieszkania za 500 000 zł oznacza to
        dodatkowe 15 000-25 000 zł. Pełną listę znajdziesz w artykule
        o <BlogLink slug="wklad-wlasny-kredyt-hipoteczny">wkładzie własnym</BlogLink>.
      </p>
      <p className="mt-3">
        Banki akceptują różne źródła wkładu: <strong>oszczędności</strong>, <strong>darowiznę
        od rodziny</strong> (potrzebna umowa darowizny i przelew na konto),
        starą książeczkę mieszkaniową (premia gwarancyjna) lub posiadaną
        działkę/nieruchomość jako zabezpieczenie zamiast gotówki.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Krok 3: Zadbaj o historię kredytową w BIK</h2>
      <p>
        Bank, oceniając wniosek, sprawdza Twoją historię w <strong>Biurze Informacji
        Kredytowej (BIK)</strong>. Każdy wcześniejszy kredyt, karta kredytowa, limit w
        koncie i opóźnienia w spłatach trafiają do bazy. Pozytywna historia podnosi
        scoring i daje lepsze warunki. Brak historii bywa traktowany lepiej niż
        negatywna, ale gorzej niż dobra — bank wtedy musi szacować ryzyko bez danych.
      </p>
      <p className="mt-3">
        <strong>Co zrobić 3-6 miesięcy przed wnioskiem:</strong>
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Pobierz darmowy raport z BIK — sprawdź, czy nie masz błędnych wpisów</li>
        <li>Spłać i zamknij nieużywane karty kredytowe (cały limit liczy się jako zobowiązanie)</li>
        <li>Zamknij niepotrzebne limity w koncie</li>
        <li>Spłać drobne kredyty ratalne (RTV, telefon na raty) — każde 500 zł raty obniża zdolność o ~50 000 zł</li>
        <li>Nie składaj wniosków o inne kredyty tuż przed wnioskiem hipotecznym</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Krok 4: Porównaj oferty co najmniej 3-4 banków</h2>
      <p>
        Najdroższy błąd pierwszych kredytobiorców to wzięcie kredytu w „swoim" banku
        bez porównania. <strong>Różnica marży 0,3 punktu procentowego między bankami to
        około 30 000 zł</strong> w skali 25-letniego kredytu 400 000 zł. Zgodnie z
        ustawą o kredycie hipotecznym z 23 marca 2017 r. każda oferta jest ważna 21 dni
        od decyzji kredytowej — masz więc czas na zebranie kilku propozycji
        jednocześnie.
      </p>
      <p className="mt-3">
        Porównuj oferty <strong>po RRSO, nie po samym oprocentowaniu</strong>. RRSO
        (Rzeczywista Roczna Stopa Oprocentowania) zawiera wszystkie koszty — odsetki,
        prowizję, ubezpieczenia wymagane przez bank. Bank z niższym oprocentowaniem ale
        wyższą prowizją może mieć wyższe RRSO i być w sumie droższy o 30 000-50 000 zł.
        Szczegóły w artykule <BlogLink slug="rrso-kredyt-hipoteczny">o RRSO</BlogLink>.
      </p>
      <p className="mt-3">
        Na tym etapie musisz podjąć dwie kluczowe decyzje, które bank Ci zaproponuje:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>
          <strong>Raty równe czy malejące</strong> — różnica w łącznym koszcie kredytu
          400 000 zł na 25 lat to ok. 120 000 zł na korzyść rat malejących. Porównanie
          w <BlogLink slug="raty-rowne-czy-malejace">artykule o ratach</BlogLink>.
        </li>
        <li>
          <strong>Oprocentowanie stałe czy zmienne</strong> — stałe daje przewidywalność
          na 5-7 lat, zmienne jest dziś o 1-1,5 pp niższe. Decyzja zależy od Twojej
          poduszki finansowej. Porównanie w <BlogLink slug="stale-czy-zmienne-oprocentowanie">artykule
          o oprocentowaniu</BlogLink>.
        </li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Krok 5: Skompletuj dokumenty i złóż wniosek</h2>
      <p>
        Lista dokumentów zależy od banku i formy zatrudnienia, ale rdzeń jest stały:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Dowód osobisty</strong> i drugi dokument tożsamości</li>
        <li><strong>Zaświadczenie o zarobkach</strong> od pracodawcy (wzór banku) — zwykle wymagane są 3 ostatnie miesiące przy umowie o pracę</li>
        <li><strong>PIT za poprzedni rok</strong> i wyciągi z konta (3-6 miesięcy)</li>
        <li><strong>Umowa o pracę</strong> lub umowa zlecenia/B2B (przy działalności — KPiR lub PIT za 2 lata, najlepiej z dochodem stabilnym lub rosnącym)</li>
        <li><strong>Dokumenty dotyczące nieruchomości</strong>: umowa przedwstępna, odpis z księgi wieczystej, wypis z rejestru gruntów</li>
        <li><strong>Operat szacunkowy</strong> (wycena nieruchomości) — koszt 400-800 zł, zwykle organizuje bank</li>
        <li><strong>Zaświadczenie o wpłacie wkładu własnego</strong> lub umowa darowizny</li>
      </ul>
      <p className="mt-3">
        Jeśli nie jesteś na etacie, ten krok wygląda inaczej i zaczyna się znacznie
        wcześniej — bank bada 12-24 miesiące wstecz i sam wylicza Twój dochód z
        dokumentacji podatkowej. Zasady dla{' '}
        <BlogLink slug="kredyt-hipoteczny-dzialalnosc-b2b-zlecenie">działalności
        gospodarczej, B2B i umowy zlecenie</BlogLink> opisaliśmy osobno.
      </p>
      <p className="mt-3">
        Bank rozpatruje wniosek 14-30 dni. W tym czasie sprawdza Twoje dochody, historię
        w BIK, weryfikuje nieruchomość (wycena, stan prawny księgi wieczystej) i ocenia
        ryzyko. Decyzja jest wstępna lub ostateczna — wstępna mówi, że bank w zasadzie
        zgadza się na kredyt, ale wymaga uzupełnień.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Krok 6: Podpisz umowę kredytową — uważnie</h2>
      <p>
        Po pozytywnej decyzji bank przygotowuje umowę kredytową. To dokument na
        kilkadziesiąt stron, którego nikt w banku nie czyta z Tobą linijka po linijce.
        Zgodnie z ustawą o kredycie hipotecznym z 2017 r. bank ma obowiązek dać Ci
        umowę <strong>14 dni przed podpisaniem</strong> — wykorzystaj ten czas.
      </p>
      <p className="mt-3">
        <strong>Sprawdź w umowie szczególnie:</strong>
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Klauzulę o <strong>opłatach za wcześniejszą spłatę</strong> — bank może pobierać prowizję maksymalnie przez 3 lata od podpisania umowy i nie wyższą niż 3% nadpłacanej kwoty. Po 3 latach nadpłaty muszą być bezpłatne.</li>
        <li>Mechanizm zmiany oprocentowania — częstotliwość aktualizacji WIBOR (zwykle 3M lub 6M) i zasady przeliczania raty</li>
        <li>Wymagane ubezpieczenia — banki często warunkują obniżkę marży zakupem ubezpieczenia w konkretnej firmie</li>
        <li>Sankcje za opóźnienia w spłacie i procedurę wypowiedzenia umowy</li>
        <li>Cesję wierzytelności z polisy ubezpieczeniowej i hipotekę kaucyjną</li>
      </ul>
      <p className="mt-3">
        Jeśli czegoś nie rozumiesz — pytaj na piśmie, najlepiej e-mailem. Doradca ustnie
        powie wszystko, ale w razie sporu liczy się tekst umowy.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Krok 7: Akt notarialny i uruchomienie kredytu</h2>
      <p>
        Po podpisaniu umowy kredytowej idziesz do notariusza, gdzie podpisujesz
        <strong> akt notarialny zakupu nieruchomości</strong>. Bank wypłaca pieniądze
        sprzedającemu (bezpośrednio na jego konto), a Ty stajesz się właścicielem
        mieszkania. Notariusz zgłasza wpis do księgi wieczystej, a bank ustanawia
        hipotekę na nieruchomości jako zabezpieczenie kredytu.
      </p>
      <p className="mt-3">
        <strong>Co dzieje się w dniu aktu notarialnego:</strong>
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Płacisz <strong>taksę notarialną</strong> (1 000-3 000 zł zależnie od wartości)</li>
        <li>Płacisz <strong>podatek PCC 2%</strong> przy rynku wtórnym (zgodnie z ustawą Ministerstwa Finansów) — przy rynku pierwotnym PCC nie obowiązuje</li>
        <li>Płacisz <strong>opłaty sądowe</strong> za wpis własności i hipoteki (~400-500 zł)</li>
        <li>Bank uruchamia kredyt — pieniądze trafiają do sprzedającego, najczęściej tego samego dnia lub następnego</li>
        <li>Pierwsza rata pojawi się 30-45 dni po uruchomieniu kredytu</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak długo trwa cały proces?</h2>
      <p>
        Pełna ścieżka od decyzji „chcę kupić mieszkanie" do podpisania aktu
        notarialnego trwa zwykle <strong>2-4 miesiące</strong>. Rozkłada się tak:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Tydzień 1-2:</strong> kalkulacja zdolności, zebranie pierwszych dokumentów, wstępne rozmowy w bankach</li>
        <li><strong>Tydzień 2-6:</strong> oglądanie mieszkań, wybór, umowa przedwstępna ze sprzedającym</li>
        <li><strong>Tydzień 6-10:</strong> złożenie wniosków w 3-4 bankach, oczekiwanie na decyzje (14-30 dni każdy)</li>
        <li><strong>Tydzień 10-12:</strong> wycena nieruchomości, finalizacja wybranej oferty, czas na przeczytanie umowy</li>
        <li><strong>Tydzień 12-16:</strong> podpisanie umowy kredytowej, akt notarialny, uruchomienie kredytu</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Najczęstsze błędy pierwszych kredytobiorców</h2>
      <p>
        Brak doświadczenia z formalnościami bankowymi to największa pułapka. Najczęstsze
        błędy to wzięcie maksymalnego kredytu (zamiast komfortowej raty 25-30%
        dochodu), branie pierwszej proponowanej oferty bez porównania, niedoliczenie
        kosztów transakcyjnych i wydanie wszystkich oszczędności na wkład bez
        poduszki finansowej. Każdy z tych błędów kosztuje od kilku do kilkudziesięciu
        tysięcy złotych w skali całej spłaty. Pełna lista wraz z konkretnymi kwotami
        — w artykule <BlogLink slug="najczestsze-bledy-kredyt-hipoteczny">o 7 najczęstszych
        błędach przy kredycie</BlogLink>.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Czy potrzebujesz doradcy kredytowego?</h2>
      <p>
        Doradca kredytowy (pośrednik) porównuje za Ciebie oferty banków i pomaga skompletować
        dokumenty. <strong>Jego usługa jest dla klienta bezpłatna</strong> — wynagrodzenie
        płaci bank w postaci prowizji za pozyskanego klienta. Brzmi atrakcyjnie, ale uważaj:
        doradca zarabia więcej na wybranych bankach (różne stawki prowizji), więc nie
        zawsze rekomenduje obiektywnie najlepszą ofertę dla Ciebie.
      </p>
      <p className="mt-3">
        <strong>Sprawdź doradcę w rejestrze pośredników KNF</strong> — pośrednik kredytu
        hipotecznego ma obowiązek być wpisany. Zapytaj wprost, w jakich bankach ma najwyższą
        prowizję — uczciwy doradca odpowie. Nawet z doradcą zrób własne porównanie
        z kalkulatorem online, żeby zweryfikować jego rekomendację.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Checklist — co zrobić przed pierwszym wnioskiem o kredyt</h2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li>Oblicz zdolność kredytową i ustal bezpieczny budżet (rata maks. 35% dochodu netto)</li>
        <li>Zbierz wkład własny — minimum 10%, optymalnie 20% wartości mieszkania</li>
        <li>Doliczam 3-5% wartości na koszty transakcyjne (PCC, notariusz, prowizje)</li>
        <li>Zachowaj poduszkę finansową na 3-6 miesięcy wydatków po zamknięciu zakupu</li>
        <li>Pobierz raport BIK, spłać karty kredytowe, zamknij niepotrzebne limity</li>
        <li>Porównaj oferty co najmniej 3-4 banków — po RRSO, nie po oprocentowaniu</li>
        <li>Zdecyduj o ratach (równe/malejące) i oprocentowaniu (stałe/zmienne) świadomie</li>
        <li>Przeczytaj całą umowę kredytową przed podpisaniem (masz na to 14 dni z mocy ustawy)</li>
      </ul>

      <div className="mt-6">
        <CalculatorLink>
          Zacznij od kalkulatora — sprawdź swoją sytuację
        </CalculatorLink>
      </div>

      <p className="text-xs text-muted-foreground mt-8 pt-4 border-t border-border/50">
        <span className="font-semibold">Źródła:</span> ustawa o kredycie hipotecznym z 23 marca 2017 r. · KNF (Rekomendacja S, rejestr pośredników kredytu hipotecznego) · Ministerstwo Finansów (ustawa o PCC) · BIK (raporty kredytowe) · NBP (stopy procentowe)
      </p>
    </>
  )
}
